import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/util";
import { Loader, Section, Money } from "@/components/common";
import FeeManager from "@/components/FeeManager";
import { Table, Td } from "@/pages/admin/ui";

export default function FeeStatement() {
  const { driverId } = useParams();
  const [p, setP] = useState(null);
  const load = useCallback(async () => {
    try {
      const [d, s] = await Promise.all([api.get(`/drivers/${driverId}`), api.get(`/fees/statement/${driverId}`)]);
      setP({ driver: d.data.driver, s: s.data });
    } catch (e) { toast.error(errMsg(e)); setP(false); }
  }, [driverId]);
  useEffect(() => { load(); }, [load]);
  if (p === null) return <Loader />;
  if (!p) return <p>غير موجود</p>;
  return (
    <div className="space-y-5">
      <Link to="/admin/fees" className="btn btn-sm btn-ghost"><ArrowRight className="w-4 h-4" />الرسوم والدفعات</Link>
      <h1 className="text-3xl font-black">كشف حساب: {p.driver.full_name} <span className="ltr text-slate-500 text-xl">{p.driver.serial}</span></h1>
      <Section title="الرسوم والدفعات"><FeeManager driver={p.driver} s={p.s} reload={load} /></Section>
      <Section title="دفتر الحركات">
        <Table head={["التاريخ", "البيان", "مدين", "دائن", "الرصيد"]} testid="ledger-table">
          {p.s.ledger.map((r, i) => <tr key={i}><Td>{fmtDate(r.date)}</Td><Td>{r.label}</Td><Td>{r.debit ? <Money fils={r.debit} /> : ""}</Td>
            <Td>{r.credit ? <Money fils={r.credit} className="text-green-700" /> : ""}</Td><Td><Money fils={r.balance} /></Td></tr>)}
        </Table>
      </Section>
    </div>
  );
}
